<!-- preloading -->

<style lang='scss' type='stylesheet/scss' scoped>
#loading {
  display: block;
  opacity: 1;
  #loading-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    img {
      width: 100%;
      height: 100%;
      display: inline-block;
    }
  }

  .bar {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -120px;
    text-align: center;
    overflow: auto;
    width: 100%;

    img {
      display: inline-block;
    }
    .typing_loader {
      display: block;
      margin: 0 auto;
      width: 200px;
      height: 9px;
      background-color: white;
      margin-top: 35px;
      position: relative;
    }
    .loding-line {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 0;
      background: #e5b12d;
      z-index: 2;
    }

    .num {
      font-size: 30px;
      margin-top: 20px;
      display: block;
      color: #e5b12d;
      font-family: "fzkatong-m19sregular";
    }
  }
}

.container {
  transition: opacity 0.4s ease;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
</style>

<template>
  <div class="container" v-if="showSelf" :style="{opacity}">
    <div class="page" id="loading">
      <div id="loading-bg">
        <img src="@/images/loading-bg.png" />
      </div>
      <div class="bar">
        <img src="@/images/cup.png" id="loading-img" />
        <div class="typing_loader">
          <div class="loding-line" :style="'width:'+(count/total*100)+'%'" id="loding-line"></div>
        </div>
        <div class="num">{{parseInt(count/total*100)}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      opacity: 1,
      showSelf: true,
      count: 0,
      total: 0,
      imgs: [
        require("../products/l-1.png"),
        require("../products/l-2.png"),
        require("../products/l-3.png"),
        require("../products/l-4.png"),
        require("../products/l-5.png"),
        require("../products/l-6.png"),
        require("../products/l-7.png"),
        require("../products/dl-1.png"),
        require("../products/dl-2.png"),
        require("../products/dl-3.png"),
        require("../products/dl-4.png"),
        require("../products/dl-5.png"),
        require("../products/dl-6.png"),
        require("../products/dl-7.png"),
        require("../products/r-1.png"),
        require("../products/r-2.png"),
        require("../products/r-3.png"),
        require("../products/r-4.png"),
        require("../products/r-5.png"),
        require("../products/r-6.png"),
        require("../products/r-7.png"),
        require("../products/r-8.png"),
        require("../products/r-9.png"),
        require("../products/dr-1.png"),
        require("../products/dr-2.png"),
        require("../products/dr-3.png"),
        require("../products/dr-4.png"),
        require("../products/dr-5.png"),
        require("../products/dr-6.png"),
        require("../products/dr-7.png"),
        require("../products/dr-8.png"),
        require("../products/dr-9.png"),

        require("../images/$0.png"),
        require("../images/$2.png"),
        require("../images/$4.png"),
        require("../images/$5.5.png"),
        require("../images/$7.png"),
        require("../images/$8.5.png"),
        require("../images/$9.png"),
        require("../images/$10.5.png"),
        require("../images/$12.png"),
        require("../images/$14.png"),
        require("../images/$15.5.png"),
        require("../images/add-red.png"),
        require("../images/add-white.png"),
        require("../images/back.png"),
        require("../images/btn.png"),
        require("../images/page1-bg-1.png"),
        require("../images/page1-bg-bottom-0.png"),
        require("../images/page1-bg-bottom-1.png"),
        require("../images/page2-bg-1.png"),
        require("../images/page2-bottom.png"),
        require("../images/page2-top.png"),
        require("../images/red-number.png"),
        require("../images/save.png"),
        require("../images/white-number.png")
      ]
    };
  },
  mounted() {
    TweenMax.fromTo(
      $("#loading-img"),
      0.6,
      {
        rotationZ: 0
      },
      {
        rotationZ: 9,
        ease: Power0.easeNone,
        repeat: -1,
        yoyo: true
      }
    );
    this.preload();
  },
  methods: {
    preload() {
      this.total = this.imgs.length;

      if (this.imgs.length === 0) {
        this.showSelf = false;
        this.$emit("done");
      }

      for (let img of this.imgs) {
        let image = new Image();
        image.src = img;
        image.onload = () => {
          this.count++;
          if (this.count === this.total) {
            this.$emit("done");
            this.opacity = 0;
            setTimeout(() => {
              this.showSelf = false;
            }, 400);
          }
        };
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/loading.vue